import { Form, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'

interface IProps {
  onSubmit: (values) => void
}

const CorporateSearch = ({ onSubmit }: IProps) => {
  const [form] = Form.useForm()
  const onFinish = (values) => {
    const objSearch = {
      keyword: values.keyword,
    }
    onSubmit(objSearch)
  }

  const [keyword, setKeyword] = useState<string>('')
  const [debouncedKeyword, setDebouncedKeyword] = useState<string>('')
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedKeyword(keyword)
    }, 500)

    return () => {
      clearTimeout(handler)
    }
  }, [keyword])

  useEffect(() => {
    if (debouncedKeyword) {
      form.submit()
    }
  }, [debouncedKeyword])

  const onSearchKeyword = (value: any, field: string) => {
    if (!value) {
      form.setFieldValue(field, undefined)
      form.submit()
    }
    if (value && value?.length > 3) {
      setKeyword(value)
    }
  }

  return (
    <div>
      <Form
        name='search-corporate'
        form={form}
        onFinish={onFinish}
        autoComplete='off'
        className='flex gap-2'
      >
        <Form.Item name='keyword' className='w-80'>
          <Input
            size='large'
            suffix={<SearchOutlined className='text-black text-opacity-25' />}
            placeholder='Corporate name, number or tax id'
            allowClear
            onChange={(event) => onSearchKeyword(event.target.value, 'keyword')}
          />
        </Form.Item>
      </Form>
    </div>
  )
}

export default CorporateSearch
